<template>
    <div class="media-library-item">
        <div 
                class="media-library-item-icon" 
                v-on:click="$emit('item-clicked')"
                v-on:dblclick="$emit('item-double-clicked')"
        >
            <slot></slot>
        </div>
        
        <div class="media-library-item-name" @click="isEditing = true">
            <span v-if="!isEditing">{{ (displayName || name) | truncate(20) }}</span>

            <input
                    class="form-control"
                    type="text"
                    ref="newNameInput"
                    v-if="isEditing"
                    v-model="newName"
                    v-bind:placeholder="nameEditorPlaceholder"
                    v-on:blur="isEditing = false"
                    v-on:keyup.enter="itemRenamed()"
            />
        </div>
    </div>
</template>

<script>
    import mediaApi from '../../../Api/media-library';
    import securityApi from "../../../Util/security";
    import truncate from '../../../Util/Filters/truncate';
    
    export default {
        name: "media-library-item",
        created (){
            const vm = this;
            
            //Initialize newName with this.name
            vm.newName = this.name;
            
            mediaApi.validatePermission(securityApi.PermissionGrantTypes.Write)
                .then((canWrite) => vm.canWrite = canWrite);
        },
        filters: {
            truncate
        },
        methods: {
            itemRenamed(){
                //Only emit renamed event when item has actually been renamed
                if(this.name !== this.newName){
                    this.$emit('item-renamed', this.newName);    
                }
                
                this.isEditing = false;
            }
        },
        data(){
            return {
                canWrite: false,
                isEditing: false,
                newName: ''
            }
        },
        watch: {
            isEditing(value){
                if(!value){
                    //Reset newName
                    this.newName = this.name;
                }
                else{
                    //Upon notifying our watcher, the DOM has yet to update
                    //We'll have to wait for the next tick before we can focus our input
                    this.$nextTick(() => {
                        this.$refs.newNameInput.focus(); 
                    });
                }
            },
            name(value) {
                //Ensure newName changes along with name upon change
                this.newName = value;
            }
        },
        props: {
            name: {
                type: String,
                required: true
            },
            displayName: {
                type: String
            },
            nameEditorPlaceholder: {
                type: String,
                required: true
            }
        }
    };
</script>

<style scoped src="../Style/base-media-library-item.scss" lang="scss">
    
</style>
